<template>
  <div>
    <main class="home">
      <div class="row">
        <div class="col-12 home-headline">
          <h1>{{ getTranslations.home_home_play_and_win }}</h1>
          <p>{{ getTranslations.home_home_thousands_of_prizes }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 push-md-4"></div>
        <div class="col-sm-8 col-md-8">
            <span class="ti_scoreboard">
              <div class="ti_score">{{ userDetails.availableCoins }}</div>
            </span>
        </div>
        <div class="col-4">
        </div>
      </div>
      <div class="row">
        <div class="col-1">
        </div>
        <div class="col-10 treasure_island_menu">
          <div class="row">
            <div class="col-4"></div>
            <div class="col-4 memory-cell">
              <button @click.prevent="navigateToGameIntro('MW')" style="cursor:pointer">
                <img src="static/images/icon-memory.png"/>
              </button>
              <span class="game-title">{{ getTranslations.home_home_memory_wizard }}</span>
              <span class="coins_left" v-if="mwCoinsCost>1">{{ mwCoinsCost }} {{ getTranslations.home_home_coins }}</span>
              <span class="coins_left" v-else>{{ mwCoinsCost }} {{ getTranslations.home_home_coin }}</span>
            </div>
            <div class="col-4"></div>
          </div>
          <div class="row">
            <div class="col-4"></div>
            <div class="col-4"></div>
            <div class="col-4 odd-cell">
              <button @click.prevent="navigateToGameIntro('ODD')" style="cursor:pointer">
                <img src="static/images/icon-odd-object.png"/>
              </button>
              <span class="game-title">{{ getTranslations.home_home_odd_object }}</span>
              <span class="coins_left" v-if="oddCoinsCost>1">{{ oddCoinsCost }} {{ getTranslations.home_home_coins }}</span>
              <span class="coins_left" v-else>{{ oddCoinsCost }} {{ getTranslations.home_home_coin }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-4 spot-cell">
              <button @click.prevent="navigateToGameIntro('SD')" style="cursor:pointer">
                <img src="static/images/icon-difference.png"/>
              </button>
              <span class="game-title">{{ getTranslations.home_home_spot_the_difference }}</span>
              <span class="coins_left" v-if="sdCoinsCost>1">{{ sdCoinsCost }} {{ getTranslations.home_home_coins }}</span>
              <span class="coins_left" v-else>{{ sdCoinsCost }} {{ getTranslations.home_home_coin }}</span>
            </div>
            <div class="col-4"></div>
            <div v-if="!hideStore" class="col-4 store-cell">
              <button @click="$router.push('/home/store')" style="cursor:pointer">
                <img src="static/images/icon-store.png"/>
              </button>
              <span class="game-title">{{ getTranslations.home_home_store }}</span>
              <span class="coins_left">{{ getTranslations.home_home_buy_more_coins }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-4"></div>
            <div class="col-4 jackpot-cell"  v-if="!hideJackpot">
              <button @click="$router.push('/home/jackpot')" style="cursor:pointer">
                <img src="static/images/icon-jackpot.png" />
              </button>
              <span class="game-title">{{ getTranslations.home_home_jackpot }}</span>
              <span class="coins_left">{{ getTranslations.home_home_days_left }}</span>
            </div>
            <div class="col-4 prizes-trophy">
              <button @click="$router.push('/home/prizesAndLeaderBoards')" style="cursor:pointer"></button>
              <span>{{ getTranslations.home_home_prizes }}</span>
            </div>
          </div>
        </div>
      </div>
    </main>
    <div class="bonus_phase_outer" v-if="showOptOutPhase">
      <div class="bonus_phase promo_phase_fp" id="optout">
        <div class="bonus_phase_inner ">
          <div class="promo_phase_outer">
            <div class="bonus_phase_content promo_phase_fp">
              <p> {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_page_optout_banner_message') }} <a class="optout__link" @click.prevent="goToEditProfile">{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_page_optout_banner_click_here') }}</a></p>
            </div>
          </div>
        </div>
        <button class="bonusclose"  id="bonusclose" @click="closeBannerForOptout()"></button>
      </div>
    </div>
    <!-- dynamically change modals -->
    <component :is="currentModal"></component>

  </div>
</template>

<script>
  /* eslint no-console: "off" */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import Vue from 'vue';
import { closeBanner } from '@/common/jQuery';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import ScoreDescription from './modals/ScoreDescription';
import GameIntro from './modals/GameIntro';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'default-content',
  props: ['playGame'],
  components: {
    ScoreDescription,
  },
  mixins: [NumbersFormattingMixin],
  data() {
    return {
      gameTypeToProceed: null,
      currentModal: null,
    };
  },
  created() {
    this.showModal();
    moment.locale(this.getLocale.toLowerCase());
  },
  mounted() {
    closeBanner();
  },
  methods: {
    ...mapActions('profile', [
      'setMatchInfo',
    ]),
    ...mapMutations('game', [
      'updateGameType',
    ]),
    // todo move it to modal.js
    showModal() {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(function () {
          $('.modal, .modal-overlay').fadeOut();
          if(vm.currentModal != null) {
            vm.currentModal = null;
            vm.showModal();
            vm.$router.push('home');
          }
        });
      });
      /* eslint-enable */
    },
    goToEditProfile() {
      this.$router.push('/home/profile/edit');
    },
    closeBannerForOptout() {
      closeBanner();
    },
    navigateToGameIntro(game) {
      this.currentModal = GameIntro;
      this.updateGameType(game);
      this.showModal();
    },
  },
  computed: {
    ...mapState('common', [
      'hideStore',
      'hideJackpot',
      'userDetails',
      'jackpotCountdownDay',
      'showOptOutPhase',
      'multiOperatorInfo',
    ]),
    ...mapState('profile', [
      'sdCoinsCost',
      'mwCoinsCost',
      'oddCoinsCost',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getGameHistoryData',
      'getShowHistory',
    ]),
    orderedGames() {
      // sort games by date ascending
      return this.getGameHistoryData.slice(0).sort((a, b) => b.timestamp - a.timestamp);
    },
  },
  filters: {
    getMoment(date) {
      return moment(date).fromNow();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/DefaultContent.vue